import axios from "axios";

export default {
    async parametrosGenerales(params) {
        const config = {
            url: process.env.VUE_APP_BASE_API + "/" + "parametros-filter?size=" + params.size + "&page=" + params.page + "&orderBy=" + params.orderBy + "&typeOrder=" + params.typeOrder,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };
        const response = await axios(config);

        if (response.status == 200) {
            return (await response).data;
        } else {
            throw new Error(response.status);
        }
    },

    async updateParametros(params) {
        const config = {
            url: process.env.VUE_APP_BASE_API + "/" + "parametros/update",
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            data: JSON.stringify({ codigo: params.codigo, nombre: params.nombre, valor: params.valor, modulo: params.modulo, estado: params.estado, tipo: 1 }),
        };
        const response = await axios(config);

        if (response.status == 200) {
            return (await response).data;
        } else {
            throw new Error(response.status);
        }
    },
    async datosPersonales(params) {
        const config = {
            url: process.env.VUE_APP_BASE_API + "/negocio/user/getone_token?token=" + params.token,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',

            },
        };
        const response = await axios(config);

        if (response.status == 200) {
            return (await response).data;
        } else {
            throw new Error(response.status);
        }
    },
    async GetAllUser() {
        const config = {
            url: process.env.VUE_APP_BASE_API + "/negocio/user/user_getall_limited",
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                Authorization: localStorage.getItem('userToken'),
            },
        };
        const response = await axios(config);

        if (response.status == 200) {
            return (await response).data;
        } else {
            throw new Error(response.status);
        }
    },
    async updateDatosPerfil(params) {

        const config = {
            url: process.env.VUE_APP_BASE_API + "/" + "negocio/user/update",
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                Authorization: localStorage.getItem('userToken'),
            },
            data: JSON.stringify({

                id_usuario: params.id_usuario,
                id_tipo_usuario: params.id_tipo_usuario,
                modulo: params.modulo,
                tenant: params.tenant,
                perfil: params.perfil,
                tipo_id: params.tipo_id,
                numero_id: params.numero_id,
                primer_nombre: params.primer_nombre,
                segundo_nombre: params.segundo_nombre,
                primer_apellido: params.primer_apellido,
                segundo_apellido: params.segundo_apellido,
                celular: params.celular,
                id_proveedor: params.id_proveedor,
                id_cliente: params.id_cliente,
            }),
        };
        const response = await axios(config);
       
        if (response.status == 200) {
            return (await response).data;
        } else {
          
          return false;
        }
    },
    async listasDesplegables(params) {

        const config = {
            url: process.env.VUE_APP_BASE_API + "/" + "negocio/consulta-entidad",
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                Authorization: localStorage.getItem('userToken'),
            },
            data: JSON.stringify({
                nombre_entidad: params.nombre_entidad
            }),
        };
        const response = await axios(config);

        if (response.status == 200) {
            return (await response).data;
        } else {
            throw new Error(response.status);
        }
    },
    async listasDesplegablesXId(params) {

        const config = {
            url: process.env.VUE_APP_BASE_API + "/" + "negocio/consulta-entidad-id",
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                Authorization: localStorage.getItem('userToken'),
            },
            data: JSON.stringify({
                nombre_entidad: params.nombre_entidad,
                id:params.id
            }),
        };
        const response = await axios(config);

        if (response.status == 200) {
            return (await response).data;
        } else {
            throw new Error(response.status);
        }
    },
    async getMetaData(params,where,relaciones) {
        const config = {
            url: process.env.VUE_APP_BASE_API + "/negocio/get-query-by-entidades",
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                Authorization: localStorage.getItem('userToken'),

            },
            data: JSON.stringify({
                    "entidad": {
                      "nombre": params.nombreEntidad,
                      "idVersion": params.idVersion,
                      "order": {
                        "column": params.column,
                        "type": params.type
                      },
                      "size": params.size,
                      "page": params.page,
                      "where": where,
                      "relaciones": relaciones,
                    }
                  
            }),
        };

        

        const response = await axios(config);
        if (response.status == 200) {
            return (await response).data;
            
        } else {
            return false
        }

    },
    async getMenuPerfil(params) {
        const config = {
            url: process.env.VUE_APP_BASE_API + "/perfil-menu?id_perfil=" + params.id_perfil,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                Authorization: localStorage.getItem('userToken'),

            },
        };
        const response = await axios(config);

        if (response.status == 200) {
            return (await response).data;
        } else {
            throw new Error(response.status);
        }
    },
    async getPerfilPermisos(params) {
        const config = {
            url: process.env.VUE_APP_BASE_API + "/perfil-permisos?id_perfil=" + params.id_perfil + "&path_url=" + params.path_url,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                Authorization: localStorage.getItem('userToken'),
            },
        };
        const response = await axios(config);

        if (response.status == 200) {
            return (await response).data;
        } else {
            throw new Error(response.status);
        }
    },
    async updateUserStatus(params) {
        const config = {
            url: process.env.VUE_APP_BASE_API + "/negocio/user/statusupdate",
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                Authorization: localStorage.getItem('userToken'),
            },
            data: JSON.stringify({
                id_usuario: params.id_usuario,
                estado: params.estado
            }),
        };
        const response = await axios(config);

        if (response.status == 200) {
            return (await response).data;
        } else {
            throw new Error(response.status);
        }
    },
    async updateUserEstado(params) {
        const config = {
            url: process.env.VUE_APP_BASE_API + "/negocio/user/estadoupdate",
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                Authorization: localStorage.getItem('userToken'),
            },
            data: JSON.stringify({
                id_usuario: params.id_usuario,
                estado: params.estado
            }),
        };
        const response = await axios(config);

        if (response.status == 200) {
            return (await response).data;
        } else {
            throw new Error(response.status);
        }
    },
    async changeUserPassword(params) {
        const config = {
            url: process.env.VUE_APP_BASE_API + "/negocio/user/changepassword",
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                Authorization: localStorage.getItem('userToken'),
            },
            data: JSON.stringify({
                id_usuario: params.id_usuario,
                password: params.password
            }),
        };
        const response = await axios(config);

        if (response.status == 200) {
            return (await response).data;
        } else {
            throw new Error(response.status);
        }
    },

    async getMetaListados() {
        const config = {
            url: process.env.VUE_APP_BASE_API + "/negocio/meta-listados",
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                Authorization: localStorage.getItem('userToken'),
            },
        };
        const response = await axios(config);
        if (response.status == 200) {
            return (await response).data;
        } else {
            throw new Error(response.status);
        }
    },

    async getMetaListadoById(id) {
        const config = {
            url: process.env.VUE_APP_BASE_API + "/negocio/meta-listados/" + id,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                Authorization: localStorage.getItem('userToken'),
            },
        };
        const response = await axios(config);
        if (response.status == 200) {
            return (await response).data;
        } else {
            throw new Error(response.status);
        }
    },

    async createMetaListado(data) {
        const config = {
            url: process.env.VUE_APP_BASE_API + "/negocio/meta-listados",
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                Authorization: localStorage.getItem('userToken'),
            },
            data: JSON.stringify(data),
        };
        const response = await axios(config);
        if (response.status == 200 || response.status == 201) {
            return (await response).data;
        } else {
            throw new Error(response.status);
        }
    },

    async updateMetaListado(id, data) {
        const config = {
            url: process.env.VUE_APP_BASE_API + "/negocio/meta-listados/" + id,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                Authorization: localStorage.getItem('userToken'),
            },
            data: JSON.stringify(data),
        };
        const response = await axios(config);
        if (response.status == 200) {
            return (await response).data;
        } else {
            throw new Error(response.status);
        }
    },

    async deleteMetaListado(id) {
        const config = {
            url: process.env.VUE_APP_BASE_API + "/negocio/meta-listados/" + id,
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                Authorization: localStorage.getItem('userToken'),
            },
        };
        const response = await axios(config);
        if (response.status == 200) {
            return (await response).data;
        } else {
            throw new Error(response.status);
        }
    },

    async guardarEntidad(params) {
        const config = {
            url: process.env.VUE_APP_BASE_API + "/negocio/guardar-entidad",
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                Authorization: localStorage.getItem('userToken'),
            },
            data: JSON.stringify(params),
        };
        const response = await axios(config);
        if (response.status == 200) {
            return (await response).data;
        } else {
            throw new Error(response.status);
        }
    },

    async actualizarEntidad(params) {
        const config = {
            url: process.env.VUE_APP_BASE_API + "/negocio/actualizar-entidad",
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                Authorization: localStorage.getItem('userToken'),
            },
            data: JSON.stringify(params),
        };
        const response = await axios(config);
        if (response.status == 200) {
            return (await response).data;
        } else {
            throw new Error(response.status);
        }
    },

    async desactivarEntidad(params) {
        const config = {
            url: process.env.VUE_APP_BASE_API + "/negocio/eliminar-tupla-entidad",
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                Authorization: localStorage.getItem('userToken'),
            },
            data: JSON.stringify(params),
        };
        const response = await axios(config);
        if (response.status == 200) {
            return (await response).data;
        } else {
            throw new Error(response.status);
        }
    }

};